/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field } from 'redux-form';
import { SelectList } from 'react-widgets';
import ArrayUtil from './ArrayUtil';
import { renderSelectList } from '../components/FormRenderField';

export const updateRangeDimensions = (oldDims, newDims, excepts = []) => {
  if (ArrayUtil.isEmpty(oldDims) || ArrayUtil.isEmpty(newDims)) {
    return oldDims;
  }
  const shapedDim = oldDims.map((dim) => {
    const matched = newDims.find(
      newDim => newDim.code === dim.code
        && (ArrayUtil.isEmpty(excepts) || (ArrayUtil.isNotEmpty(excepts) && excepts.indexOf(newDim.code) < 0)),
    );
    if (matched) {
      return {
        ...dim,
        high: matched.high,
        low: matched.low,
      };
    }
    return dim;
  });
  return shapedDim;
};

export const updatePriorDimensions = (oldDims, newDims) => {
  if (ArrayUtil.isEmpty(oldDims) || ArrayUtil.isEmpty(newDims)) {
    return oldDims;
  }
  const shapedDim = oldDims.map((dim) => {
    const matched = newDims.find(newDim => newDim.code === dim.code);
    return {
      ...dim,
      priority: matched.priority,
    };
  });
  return shapedDim;
};

export const generateDimGroup = (groups, selected = []) => {
  const dimGroupList = groups.map((group, i) => {
    const dimList = group.map((dim, j) => (
      <div key={j} className="col-md-3 col-sm-6 col-xs-12">
        <div>
          <label className="field-label">{dim.name}</label>
        </div>
        <Field
          name="dimensions"
          component={renderSelectList}
          textField="text"
          multiple
          data={dim.dimensions}
          defaultValue={selected}
        />
      </div>
    ));
    return (
      <div key={i} className="row mt10">
        {dimList}
      </div>
    );
  });

  return dimGroupList;
};

const getSelectedAbilities = (competency, selected) => {
  const comSelected = [];
  if (ArrayUtil.isNotEmpty(selected) && ArrayUtil.isNotEmpty(competency.abilities)) {
    selected.forEach((sel) => {
      const item = competency.abilities.find(ab => ab.id === sel);
      if (item) {
        comSelected.push(item);
      }
    });
  }
  return comSelected;
};

export const generateCompetencyGroupNoForm = (groups, options = {}, selected = []) => {
  const compGroupList = groups.map((group, i) => {
    const dimList = group.map((comp, j) => {
      const selectedAbilities = getSelectedAbilities(comp, selected);

      return ArrayUtil.isNotEmpty(selectedAbilities) ? (
        <div key={j} className="col-sm-6 col-xs-12">
          <div>
            <label className="field-label">{comp.displayName}</label>
          </div>
          <SelectList
            {...options}
            textField="displayName"
            valueField="id"
            defaultValue={selected}
            multiple
            data={selectedAbilities}
          />
        </div>
      ) : null;
    });
    return (
      <div key={i} className="row mt10">
        {dimList}
      </div>
    );
  });

  return compGroupList;
};

export const generateDimGroupNoForm = (groups, options = {}) => {
  const dimGroupList = groups.map((group, i) => {
    const dimList = group.map((dim, j) => (
      <div key={j} className="col-md-3 col-sm-6 col-xs-12">
        <div>
          <label className="field-label">{dim.name}</label>
        </div>
        <SelectList {...options} textField="text" defaultValue={dim.selected} multiple data={dim.dimensions} />
      </div>
    ));
    return (
      <div key={i} className="row mt10">
        {dimList}
      </div>
    );
  });

  return dimGroupList;
};

export const addSelectedToCompetencyList = (competencies) => {
  const newList = competencies.map(comp => comp);
  return newList || [];
};
